import React from "react";
import pdfFile from "../pdfs/Tipkit-ValetGuide-english.pdf";
import PdfViewer from "../comman/PdfViewer";
import { onboardingDocs } from "../consfig";

const ValentGuideEnglish = () => {
  const pdfUrl = onboardingDocs.b2c.valet;
  return <PdfViewer pdfFile={pdfUrl} />;
};

export default ValentGuideEnglish;
